import React from 'react';
import {Context} from '../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import i18n from '../../i18n';
import {useTranslation} from 'react-i18next';
import DashboardCards from '../../components/Dashboard/DashboardCards_obs';
import DashboardGraphics from '../../components/Dashboard/DashboardGraphics_obs';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ContasLeads from '../../components/Dashboard/ContasLeads';
import Vendas from '../../components/Dashboard/Vendas';

function Dashboard(params) {
    // const history = useHistory();
    const {t} = useTranslation();

    // Separador que está visivel
    const [openTab, setOpenTab] = React.useState(1);
    return (
        <>
            {/* <DashboardCards /> */}
            <div className="flex w-full max-w-45 mt-5 " role="tablist" id="myTab" data-tabs-toggle="#myTabContent">
                <div className="inline-flex p-2  items-center rounded-[8px] bg-gray-100  dark:bg-gray-600">
                    <button
                        onClick={e => {
                            e.preventDefault();
                            setOpenTab(1);
                        }}
                        aria-controls="agenda"
                        id="agenda-tab"
                        type="button"
                        data-toggle="tab"
                        href="#link1"
                        role="tablist"
                        aria-current="page"
                        className={
                            `rounded  py-2 px-3 mr-1 text-sm font-medium text-black shadow-card hover:bg-white hover:shadow-card  dark:text-white dark:hover:bg-gray-700 ` +
                            (openTab === 1 ? 'bg-white dark:bg-gray-700' : '')
                        }>
                        {t('carteiraContasLeads')}
                    </button>
                    <button
                        onClick={e => {
                            e.preventDefault();
                            setOpenTab(2);
                        }}
                        aria-controls="agenda"
                        id="agenda-tab"
                        type="button"
                        data-toggle="tab"
                        href="#link1"
                        role="tablist"
                        aria-current="page"
                        className={
                            `rounded  py-2 px-3 mr-1 text-sm font-medium text-black shadow-card hover:bg-white hover:shadow-card  dark:text-white dark:hover:bg-gray-700 ` +
                            (openTab === 2 ? 'bg-white dark:bg-gray-700' : '')
                        }>
                        {t('vendas')}
                    </button>
                    {/* <button
                        onClick={e => {
                            e.preventDefault();
                            setOpenTab(3);
                        }}
                        aria-controls="agenda"
                        id="agenda-tab"
                        type="button"
                        data-toggle="tab"
                        href="#link1"
                        role="tablist"
                        aria-current="page"
                        className={
                            `rounded  py-2 px-3 text-sm font-medium text-black shadow-card hover:bg-white hover:shadow-card  dark:text-white dark:hover:bg-gray-700 ` +
                            (openTab === 3 ? 'bg-white dark:bg-gray-700' : '')
                        }>
                        {t('atividade')}
                    </button> */}
                </div>
            </div>
            <div className="border-b mb-5 mt-2 border-gray-200 dark:border-gray-600"></div>
            <div>{openTab == 1 && <ContasLeads />}</div>
            <div>{openTab == 2 && <Vendas />}</div>
        </>
    );
}

export default Dashboard;
